import React from 'react';
const skills = ['Posicionamiento', 'Buyer Persona', 'Contenido', 'Reels', 'Copywriting', 'Meta Ads', 'Segmentación', 'Funnel de ventas', 'Cierre por DM', 'Hashtags', 'Algoritmo', 'Fidelización'];
export function ProductPresentation() {
  return <section className="py-20 bg-slate-50 px-4" data-id="element-273">
      <div className="max-w-6xl mx-auto" data-id="element-274">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-275">
          <div className="w-full lg:w-1/2" data-id="element-276">
            <div className="relative max-w-md mx-auto rounded-3xl shadow-xl border border-slate-100 overflow-hidden" data-id="element-277">
              <img src="https://cdn.magicpatterns.com/uploads/kiyBPiRsueF3DpmXBFiaRx/WhatsApp_Image_2026-06-03_at_7.29.02_PM.jpg" alt="Pack Publicidad en Redes Sociales — 6 guías incluidas" className="w-full h-auto block" data-id="element-278" />
            </div>
          </div>

          <div className="w-full lg:w-1/2" data-id="element-279">
            <div className="inline-block bg-sky/10 text-sky-hover font-semibold px-4 py-1.5 rounded-full text-sm mb-6" data-id="element-280">
              Sistema completo · Argentina 2025
            </div>

            <h2 className="text-3xl md:text-4xl font-bold text-navy mb-6" data-id="element-281">
              Mega Pack Publicidad en Redes Sociales para Emprendedores
            </h2>

            <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-282">
              6 guías paso a paso + 4 bonos estratégicos. Todo lo que necesitás
              para dominar Instagram y Facebook, conseguir compradores reales y
              hacer crecer tu emprendimiento. Descargás y aplicás desde el día
              uno.
            </p>

            <div className="flex flex-wrap gap-4 mb-10" data-id="element-283">
              <div className="bg-white px-4 py-2 rounded-lg shadow-sm border border-slate-100 font-medium text-navy" data-id="element-284">
                +200 páginas
              </div>
              <div className="bg-white px-4 py-2 rounded-lg shadow-sm border border-slate-100 font-medium text-navy" data-id="element-285">
                6 guías
              </div>
              <div className="bg-white px-4 py-2 rounded-lg shadow-sm border border-slate-100 font-medium text-navy" data-id="element-286">
                4 bonos
              </div>
              <div className="bg-white px-4 py-2 rounded-lg shadow-sm border border-slate-100 font-medium text-navy" data-id="element-287">
                Instagram & Facebook
              </div>
              <div className="bg-white px-4 py-2 rounded-lg shadow-sm border border-slate-100 font-medium text-navy" data-id="element-288">
                Meta Ads
              </div>
            </div>

            <div data-id="element-289">
              <h4 className="font-bold text-navy mb-4" data-id="element-290">
                Habilidades que vas a dominar:
              </h4>
              <div className="flex flex-wrap gap-2" data-id="element-291">
                {skills.map((skill, idx) => <span key={idx} className="bg-slate-200 text-slate-700 px-3 py-1 rounded-full text-sm" data-id="element-292">
                    {skill}
                  </span>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}